export const fullScreenDialogSx = {
  width: '100%',
  height: '100%',
  borderRadius: 0,
  maxWidth: 'unset!important',
  maxHeight: 'unset!important',
  margin: 0,
  padding: 0,
};

export const legacyPaperStyle = { padding: 3.75 };
export const legacyActionSyle = { padding: 0, marginTop: 1.25 };
export const topScrollPaper = { alignItems: 'flex-start' };
export const topPaperScrollBody = { verticalAlign: 'top' };
